import { PopulationResponse } from '../../../../shared/interfaces';
import { ISlideData } from 'src/app/modules/carousel/interfaces';
import { ActivityState } from './activity-state';
import { ClickstreamInteraction } from 'src/app/modules/olp-api/types/clickstream-interaction.interface';

export interface IncompleteActivityState extends ActivityState {
  currentStep: number;
  populationResponses: PopulationResponse[];
  filledAnswers?: (string | number)[][];
  selectedAnswers?: (string | number)[][];
  disabledAnswers?: (string | number)[][];
  curHintsRevealed?: ISlideData[];
  activitySeed?: string;
  currentActivityOid: number;
  clickstreamInteractions: ClickstreamInteraction[];
  inboxActivityId?: string;
  inboxAssignmentId?: string;
}
